<template>
  <mdb-container fluid v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
          <strong>Usuarios</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline>
            <input v-on:keydown.enter.prevent="''" class="mr-sm-2 filter-input" type="text" v-model="search"
              style="width: 100% !important; border: 0px !important;"
              placeholder="Buscar usuario por nombre, correo o tipo de usuario" />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;">
            <div class="text-left">
              <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                <span slot="tip">Alta usuario</span>
                <a slot="reference" @click="showModal = true; userName = '';">
                  <img alt="alta usuario" class="mt-0" :src="imgServer + 'apps/myfrac/admin/assets/Crear_BTN@3x.png'"
                    style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;" />
                </a>
              </mdb-tooltip>
            </div>

            <span class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; display: table; margin: 0 auto;">Usuarios
              registrados</span>

            <div class="text-right" style=" margin-top: -10px; display: flex; float: right;"></div>
          </div>
          <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-center" responsive>
                  <tr>
                    <th scope="col">Correo/Código</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Tipo de usuario</th>
                    <th scope="col">Fraccionamiento</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body class="text-center">
                  <tr v-for="(item, index) in displayedPost" v-bind:key="index">
                    <td v-if="item.idUsersTypes != 5 && item.idUsersTypes != 6">{{ item.email }}</td>
                    <td v-else>{{ item.email.split('-')[1] }}</td>
                    <td>{{ item.firstName }}</td>
                    <td>{{ item.testUsersType.name }}</td>
                    <td v-if="item.testFrac">{{ item.testFrac.name }}</td>
                    <td v-else></td>
                    <td>
                      <div>
                        <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Editar</span>
                          <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 button_background"
                            @click="getSingleUser(item.uuid)">
                            <mdb-icon icon="edit" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Eliminar</span>

                          <mdb-btn slot="reference" outline="white" rounded size="sm"
                            class="px-2 ml-2 button_background" style="width: 2rem;"
                            @click="deleteUser(item.uuid, item.name)">
                            <mdb-icon icon="trash" />
                          </mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <!-- Componente de Paginación -->
              <Pagination :currentPage="page" :totalPages="numberOfPages" @page-change="goToPage" />
            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->

    <mdb-modal :show="showModal" @close="closeModal" size="lg">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff;">{{ TitleModal }} usuario</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-col>
          <form id="userForm" class="needs-validation" novalidate @submit="submitForm">
            <mdb-row>
              <mdb-col>
                <div class="form-group">
                  <label style="font-family: OpenSans-Semibold;">Tipo usuario</label>
                  <model-select v-if="whoami.idUsersTypes == 14" :options="typeUsersIntegrator" class
                    v-model="typeModel" style="height: 37px; margin-top: 10px; "
                    placeholder="Selecciona un tipo de usuario" :isError="typeValid"
                    :isDisabled="typeModel.value == 15"></model-select>
                  <model-select v-else :options="typeUsers" class v-model="typeModel"
                    style="height: 37px; margin-top: 10px; " placeholder="Selecciona un tipo de usuario"
                    :isError="typeValid"
                    :isDisabled="userObject.uuid == userMe.uuid || typeModel.value == 15"></model-select>
                </div>
              </mdb-col>
              <mdb-col>
                <div v-if="typeModel.value != 5 && typeModel.value != 6" class="form-group">
                  <label style="font-family: OpenSans-Semibold;">Correo electrónico</label>
                  <input type="email" class="form-control text-input" id="email" required maxlength="64" minlength="7"
                    v-model="userEmail" style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                    :disabled="userObject.uuid == userMe.uuid" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Asigna un correo valido</div>
                </div>
                <div v-else class="form-group">
                  <label style="font-family: OpenSans-Semibold;">Código</label>
                  <input type="text" class="form-control text-input" id="code" required maxlength="4" minlength="4"
                    v-model="userEmail" style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Asigna un codigo correcto</div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col>
                <div class="form-group">
                  <label for="userName" style="font-family: OpenSans-Semibold; font-size: 12px">Nombre</label>
                  <input type="text" class="form-control text-input" id="userName" required maxlength="64" minlength="1"
                    v-model="userName" style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Asigna un nombre</div>
                </div>
              </mdb-col>
              <mdb-col>
                <div class="form-group">
                  <label for="lastName" style="font-family: OpenSans-Semibold; font-size: 12px">Apellido</label>
                  <input type="text" class="form-control text-input" id="lastName" required maxlength="64" minlength="3"
                    v-model="lastName" style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Asigna un apellido</div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="whoami.idUsersTypes == 14 && typeModel.value != 14">
              <mdb-col>
                <div class="form-group">
                  <label for="userName" style="font-family: OpenSans-Semibold; font-size: 12px">Código Postal</label>
                  <input type="text" class="form-control text-input" id="userCP" required v-model="userCP"
                    style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                    @keyup="getAddressInformation" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Este campo es obligatorio</div>
                </div>
              </mdb-col>
              <mdb-col>
                <div class="form-group">
                  <label for="lastName" style="font-family: OpenSans-Semibold; font-size: 12px">Ciudad</label>
                  <input type="text" class="form-control text-input" id="userCity" required disabled v-model="userCity"
                    style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Este campo es requerido</div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="whoami.idUsersTypes == 14 && typeModel.value != 14">
              <mdb-col>
                <div class="form-group">
                  <label for="userName" style="font-family: OpenSans-Semibold; font-size: 12px">Estado</label>
                  <input type="text" class="form-control text-input" id="userState" required v-model="userState"
                    disabled style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Este campo es obligatorio</div>
                </div>
              </mdb-col>
              <mdb-col>
                <div class="form-group">
                  <label style="font-family: OpenSans-Semibold;">Colonia</label>
                  <model-select :options="colonyList" v-model="colonyModel" style="height: 37px;"
                    placeholder="Selecciona una colonia" :isError="colonyValid"></model-select>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="whoami.idUsersTypes == 14 && typeModel.value != 14">
              <mdb-col>
                <div class="form-group">
                  <label for="userName" style="font-family: OpenSans-Semibold; font-size: 12px">Calle</label>
                  <input type="text" class="form-control text-input" id="userStreet" required v-model="userStreet"
                    style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Este campo es obligatorio</div>
                </div>
              </mdb-col>
              <mdb-col>
                <div class="form-group">
                  <label for="lastName" style="font-family: OpenSans-Semibold; font-size: 12px">No. Exterior</label>
                  <input type="text" class="form-control text-input" id="userExtNumber" required v-model="userExtNumber"
                    style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Este campo es requerido</div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="whoami.idUsersTypes == 14 && typeModel.value != 14">
              <mdb-col>
                <div class="form-group">
                  <label for="userName" style="font-family: OpenSans-Semibold; font-size: 12px">No. Interior</label>
                  <input type="text" class="form-control text-input" id="userIntNumber" v-model="userIntNumber"
                    style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">Este campo es obligatorio</div>
                </div>
              </mdb-col>
              <mdb-col>
                <div class="form-group"></div>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <div v-if="typeModel.value == 5" class="col-12">
                <div class="form-check" style="margin-right: 10px;">
                  <input class="form-check-input" type="checkbox" v-model="vigilanteCheckboxValue" id="checkbox" />
                  <label class="form-check-label" for="checkbox">
                    Vigilante con uso de Pre-registro
                  </label>
                </div>
              </div>

              <div v-else-if="(typeModel.value == 2 || userObject.uuid == userMe.uuid) && isAdminResidentConfigured"
                class="col-12">
                <div class="row align-items-center">
                  <!-- Checkbox y su label -->
                  <div class="col-auto">
                    <div class="form-check" style="margin-right: 10px;">
                      <input class="form-check-input" type="checkbox" v-model="userUseChatbot" id="checkbox" />
                      <label class="form-check-label" for="checkbox">
                        <span style="font-family: OpenSans-Semibold;">Uso del chatbot</span>
                      </label>
                    </div>
                  </div>

                  <!-- Input para el número de teléfono, se muestra a la derecha del checkbox -->
                  <div class="col-auto" v-if="userUseChatbot">
                    <input type="number" v-model="userPhoneNumber" placeholder="Número de teléfono"
                      class="form-control text-input" style="height: 37px; font-size: 12px;" :required="userUseChatbot"
                      maxlength="10" minlength="10" />
                    <div v-if="$v.userPhoneNumber.$error" class="text-danger" style="font-size: 12px;">
                      <span v-if="!$v.userPhoneNumber.required">El número es obligatorio.</span>
                      <span v-if="!$v.userPhoneNumber.validPhone">El número debe contener 10 dígitos.</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botones en una fila separada, alineados a la derecha -->
              <div class="col-12 text-right mb-1" style="display: flex; justify-content: flex-end; margin-top: 10px;">
                <mdb-btn color="color-prev" type="button" class="btn-prev Rectngulo-14 mr-2" @click="closeModal">
                  Cancelar
                </mdb-btn>
                <mdb-btn v-if="TitleModal == 'Agregar'" type="submit" class="btn btn-next btn-color-next Rectngulo-14">
                  Registrar
                </mdb-btn>
                <mdb-btn v-else type="submit" class="btn btn-next btn-color-next Rectngulo-14">
                  Actualizar
                </mdb-btn>
              </div>
            </mdb-row>

          </form>
        </mdb-col>
      </mdb-modal-body>
    </mdb-modal>

    <residente-admin-config :showFloatingButton="mostrarBolaFlotante" @is-edit="manejarIsEdit" />

  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import { mapGetters, mapActions } from "vuex";
import Popup from "./../../core/popup";
import Pagination from "@/components/Pagination.vue";
import { showSuccessAlert, showErrorAlert } from "@/utils/alerts.js";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody
} from "mdbvue";
import { requiredIf, helpers } from 'vuelidate/lib/validators';
import residenteAdminConfig from "./visitasAdministrativas/residenteAdminConfig.vue";

export default {
  name: "Users",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    ModelSelect,
    Popup,
    Pagination,
    residenteAdminConfig,
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      search: null,
      userName: "",
      lastName: "",
      userEmail: "",
      usersList: [],
      typeModel: {
        value: "",
        text: ""
      },
      typeUsers: [
        {
          value: 4,
          text: "Administrador de fraccionamiento"
        },
        {
          value: 2,
          text: "Capturista"
        },
        {
          value: 5,
          text: "Vigilante"
        }
      ],
      typeUsersIntegrator: [
        {
          value: 4,
          text: "Administrador de fraccionamiento"
        },
        {
          value: 14,
          text: "Integrador"
        }
      ],
      typeValid: false,
      TitleModal: "Agregar",
      userObject: [],
      userCP: "",
      userCity: "",
      userState: "",
      userColony: "",
      userStreet: "",
      userIntNumber: "",
      userExtNumber: "",
      colonyList: [],
      colonyModel: {
        value: "",
        uuid: "",
        text: ""
      },
      colonyValid: false,
      vigilanteCheckboxValue: false,
      userUseChatbot: false,
      userPhoneNumber: "",
      mostrarBolaFlotante: true,
      isAdminResidentConfigured: false,
    };
  },
  validations: {
    // Validamos el campo userPhoneNumber
    userPhoneNumber: {
      required: requiredIf(function () {
        return this.userUseChatbot;
      }),
      validPhone: helpers.withParams({ type: 'validPhone' }, function (value, parentVm) {
        if (!parentVm.userUseChatbot || !value) return true;
        return /^\d{10}$/.test(value);
      })
    }
  },
  methods: {
    ...mapActions(["getAllUsers", "createUser"]),
    getAddressInformation() {
      if (this.userCP.length == 5) {
        let aux = this;
        Axios.get(Servers.serverApi + "api/addresses/" + aux.userCP, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        })
          .then(function (response) {
            aux.userState = response.data[0].state;
            aux.userCity = response.data[0].location;
            aux.colonyList = [];
            for (var i = 0; i < response.data.length; i++) {
              var temp = {
                value: response.data[i].idAddress,
                uuid: response.data[i].uuid,
                text: response.data[i].colony
              };
              aux.colonyList.push(temp);
            }
          })
          .catch(function (error) {
            // console.log(error.response.data);
            this.showMessageError("Error", error.response.data.error_description ?? 'Error interno del servidor')
          });
      }
    },
    closeModal() {
      this.showModal = false;
      this.TitleModal = "Agregar";
      this.userName = "";
      this.lastName = "";
      this.userEmail = "";
      this.userCP = "";
      this.userCity = "";
      this.userState = "";
      this.userColony = "";
      this.userStreet = "";
      this.userIntNumber = "";
      this.userExtNumber = "";
      this.typeModel = {
        value: "",
        text: ""
      };
      this.colonyModel = {
        value: "",
        uuid: "",
        text: ""
      };
      this.typeValid = false;
      this.colonyValid = false;
      this.vigilanteCheckboxValue = false;
      this.userUseChatbot = false;
      this.userPhoneNumber = "";
    },
    submitForm(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      // Expresión regular para validar correos electrónicos
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // Validación del correo electrónico
      if (this.typeModel.value != 5 && this.typeModel.value != 6) {
        if (!this.userEmail || !emailRegex.test(this.userEmail)) {
          Swal.fire({
            title: "<span style='font-size: 20px;'>Correo no válido</span>",
            html:
              "<span style='font-size: 12px;'>El texto ingresado debe ser un correo electrónico</span>",
            type: "warning",
            width: "30%",
            confirmButtonText: "Aceptar",
          });
          return; // Detiene el envío si el correo no es válido
        }
      }

      event.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (!this.userUseChatbot) {
        this.userPhoneNumber = "";
      }

      // Validación específica para el campo "Código"
      if (this.typeModel.value == 5 || this.typeModel.value == 6) {
        if (!this.userEmail || this.userEmail.length !== 4) {
          Swal.fire({
            title: "<span style='font-size: 20px;'>Código incompleto</span>",
            html:
              "<span style='font-size: 12px;'>El código debe tener exactamente 4 caracteres</span>",
            type: "warning",
            width: "30%",
            confirmButtonText: "Aceptar",
          });
          return; // Detiene la ejecución si el código no es válido
        }
      }
      if (this.typeModel.value) this.typeValid = false;
      else this.typeValid = true;
      if (this.colonyModel.value) this.colonyValid = false;
      else this.colonyValid = true;
      if (
        this.userName != "" &&
        this.lastName != "" &&
        this.userEmail != "" &&
        this.typeModel.value != "" &&
        this.whoami.idUsersTypes != 14
      ) {
        if (this.typeModel.value != 15) {
          if (this.TitleModal == "Agregar") {
            this.postUser();
          } else {
            this.putUser();
          }
        } else {
          Swal.fire({
            title: "<span style='font-size: 20px;'>Accion no permitida</span>",
            html:
              "<span style='font-size: 12px;'>No es posible dar de alta un contratista desde esta sección</span>",
            type: "warning",
            width: "30%",
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn-modal-accept"
            },
            onClose: () => {
              this.closeModal();
            }
          });
        }
      } else if (this.whoami.idUsersTypes == 14) {
        if (
          this.userName != "" &&
          this.lastName != "" &&
          this.userEmail != "" &&
          this.typeModel.value != "" &&
          this.userCP != "" &&
          this.userCity != "" &&
          this.userState != "" &&
          this.userStreet != "" &&
          this.userExtNumber != "" &&
          !this.colonyValid
        ) {
          if (this.TitleModal == "Agregar") {
            this.postUser();
          } else {
            this.putUser();
          }
        } else if (
          this.userName != "" &&
          this.lastName != "" &&
          this.userEmail != "" &&
          this.typeModel.value != "" &&
          this.whoami.idUsersTypes == 14
        ) {
          if (this.TitleModal == "Agregar") {
            this.postUser();
          } else {
            this.putUser();
          }
        }
      }
    },
    async getUsers() {
      try {
        let response = await this.getAllUsers();
        // console.log(response)
        if (response.status == 200) {
          this.usersList = response.data.filter(item => {
            return item.idUsersTypes != 15;
          });
          this.numberOfPages = Math.ceil(this.usersList.length / this.perPage)
        }

      } catch (error) {
        // console.log(error.response.data)
        this.showMessageError("Error", error.response.data.error_description ?? 'Error interno del servidor')
      }
    },
    getSingleUser(uuid) {
      this.TitleModal = "Editar";
      this.showModal = true;
      let found = this.usersList.find(element => element.uuid == uuid);
      this.userObject = found;
      this.userName = found.firstName;
      this.lastName = found.lastName;
      if (found.idUsersTypes == 5 || found.idUsersTypes == 6) {
        this.userEmail = found.vigilantCode;
      } else {
        this.userEmail = found.email;
      }
      this.typeModel.value = found.idUsersTypes == 6 ? 5 : found.idUsersTypes;
      this.typeModel.text = found.testUsersType.name;
      this.vigilanteCheckboxValue = found.idUsersTypes == 6 ? true : false;
      this.userUseChatbot = found.administrativeVisitsUser.useapp ?? false;
      this.userPhoneNumber = found.administrativeVisitsUser.phone.phone ?? "";
      if (this.whoami.idUsersTypes == 14 && found.idUsersTypes == 4) {
        this.userCP = found.address.cp;
        this.userCity = found.address.city;
        this.userState = found.address.state;
        this.userStreet = found.street;
        this.userExtNumber = found.extNumber;
        this.userIntNumber = found.intNumber;
        this.colonyModel.value = found.idAddress;
        this.colonyModel.uuid = found.address.uuid;
        this.colonyModel.text = found.address.colony;
        this.getAddressInformation();
      }
    },
    putUser() {
      const idUsersTypes = this.typeModel.value == 5 && this.vigilanteCheckboxValue ? "6" : this.typeModel.value + "";
      let aux = this;
      var data = {
        firstName: aux.userName,
        lastName: aux.lastName,
        email: aux.typeModel.value == 5 ? "" : aux.userEmail,
        vigilantCode: aux.typeModel.value != 5 ? "" : aux.userEmail,
        idUsersTypes: idUsersTypes,//aux.typeModel.value,
        city: aux.userCity,
        state: aux.userState,
        idAddress: aux.colonyModel.value,
        street: aux.userStreet,
        extNumber: aux.userExtNumber,
        intNumber: aux.userIntNumber,
        starDate: "",
        endDate: "",
        useApp: this.userUseChatbot,
        phoneNumber: this.userPhoneNumber
      };
      Axios.put(Servers.serverApi + "api/users/" + aux.userObject.uuid, data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function (response) {

          if (response.status == 200) {
            return showSuccessAlert({
              onClose: () => window.location.reload(),
            });
          }
          return showErrorAlert({
            message: response.data.error_description,
            onClose: () => window.location.reload(),
          })

        })
        .catch(error => {
          this.showMessageError("Error al editar usuario", error.response.data.error_description ?? 'Error interno del servidor')
          // console.log(error.response.data);
        });
    },
    async postUser() {
      ///REVISAR
      const idUsersTypes = this.typeModel.value == 5 && this.vigilanteCheckboxValue ? "6" : this.typeModel.value + "";
      var data = [];
      var jsonData = {
        firstName: this.userName,
        lastName: this.lastName,
        email: this.typeModel.value == 5 ? "" : this.userEmail,
        vigilantCode: this.typeModel.value != 5 ? "" : this.userEmail,
        idUsersTypes: idUsersTypes,//this.typeModel.value == 5 ? "6" :this.typeModel.value + "",
        city: this.userCity,
        state: this.userState,
        idAddress: this.colonyModel.value ? this.colonyModel.value : "",
        street: this.userStreet,
        extNumber: this.userExtNumber,
        intNumber: this.userIntNumber,
        starDate: "",
        endDate: "",
        useApp: this.userUseChatbot,
        phoneNumber: this.userPhoneNumber,
        vigilantUsername: null,
        vigilantPassword: null
      };
      data.push(jsonData);

      try {

        const response = await this.createUser([jsonData]);

        if (response.status == 200) {
          return showSuccessAlert({
            onClose: () => window.location.reload(),
          });
        }
        return showErrorAlert({
          message: response.data.error_description,
          onClose: () => window.location.reload(),
        })


      } catch (error) {
        if (error.response.status == 409) {
          const message = this.typeModel.value != 5 && this.typeModel.value != 6
            ? ["El correo ya existe", "Es posible que el correo electrónico ya haya sido registrado, por favor verifica los datos."]
            : ["El código ya existe", "Es posible que el código ya haya sido registrado, por favor verifica los datos."];

          this.showMessageError(...message);
        } else if (error.response.status == 410) {
          const message = this.typeModel.value != 5 && this.typeModel.value != 6
            ? ["Correo no disponible", "El correo electrónico ingresado pertenece a un usuario eliminado. Ingresa uno nuevo."]
            : ["Código no disponible", "El código ingresado pertenece a un usuario eliminado. Ingresa uno nuevo."];

          this.showMessageError(...message);
        }
        else {
          this.showMessageError("Error al dar de alta", error.response.data.error_description ?? 'Error interno del servidor')
        }


      }
      // Axios.post(Servers.serverApi + "api/users", data, {
      //   responseType: "application/json",
      //   headers: {
      //     Authorization: "Bearer " + localStorage.getItem("access_token")
      //   }
      // })
      //   .then(function(response) {
      //     console.log(response.data);
      //     aux.showMessageSucces();
      //   })
      //   .catch(error => {
      //     console.log(error.response.data);
      //   });
    },
    deleteUser(uuid, name) {
      let aux = this;
      Swal.fire({
        title: "¿Seguro que deseas eliminar " + name + "?",
        text: "No podrás revetir esta acción",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          Axios.delete(Servers.serverApi + "api/users/" + uuid, {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          })
            .then(function (response) {
              aux.showMessageSucces();
            })
            .catch(function (error) {
              // console.log(error.response.data);
              this.showMessageError("Error al eliminar usuario", error.response.data.error_description ?? 'Error interno del servidor')
            });
        }
      });
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    showMessageError: function (text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => { }
      });
    },
    showMessageSucces: function () {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Correcto!</span>",
        html: "<span style='font-size: 12px;'></span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          window.location.reload();
        }
      });
    },
    goToPage(pageNumber) {
      this.page = pageNumber;
      localStorage.setItem('currentPage', pageNumber);
      this.getUsers(); // Llamada para actualizar los datos según la página seleccionada
    },
    manejarIsEdit(valorIdEdit) {
      this.isAdminResidentConfigured = valorIdEdit;
    },
  },
  mounted() {
    this.getUsers();
  },
  created() {
    //this.checkMe();
    //this.whoami = JSON.parse(localStorage.getItem("me"));
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('currentSearch');
    localStorage.removeItem('currentPage'); // Limpiar la página actual cuando se cambie de ruta

    next();
  },
  watch: {
    colonyModel(newColony) {
      this.colonyModel = newColony;
      if (newColony.value) {
        this.colonyValid = false;
      } else {
        this.colonyModel = true;
      }
    },
    usersList() {
      this.setPages();
    },
    search() {
      this.page = 1;
      localStorage.setItem('currentSearch', this.search);
      localStorage.setItem('currentPage', this.page);
      this.getUsers();
      //this.currentTime = new Date().getTime();
    },
    page() {
      this.getUsers();
    },
  },
  computed: {
    ...mapGetters({
      whoami: "getWhoAmi",
      userMe: "getUserInfo",
    }),
    displayedPost() {
      if (this.search) {
        //this.page = 1;
        this.page = parseInt(localStorage.getItem('currentPage')) || 1;
        return this.paginate(
          this.usersList.filter(item => {
            return (
              item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
              item.email.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
              item.testUsersType.name
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0
            );
          })
        );
      } else return this.paginate(this.usersList);
    },
  }
};
</script>

<style scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1;
  /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table>tbody {
  text-align: center;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.table>tbody>tr>td {
  text-align: center !important;
}
</style>